<template>
  <b-container>
    <WizardPageTitle title="Project Details" />
    <b-row>
      <b-col>
        <b-form>
          <b-form-group
            label="Project name"
            description="A human-readable project name, for example 'Book Library'"
            :state="errState($v.name)"
            invalid-feedback="A valid project name is required"
          >
            <b-form-input
              v-model="$v.name.$model"
              type="text"
              :state="errState($v.name)"
            />
          </b-form-group>
          <b-form-group
            label="Platform"
            description="Framework to use for the project"
          >
            <b-form-select
              v-model="platform"
              :options="platformChoices"
              disabled
            />
          </b-form-group>
          <b-form-group
            label="Description"
            description="A short (one-paragraph) description of the project for README"
          >
            <b-form-textarea
              v-model="description"
              rows="5"
            />
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <WizardPrevNext
      :disabled="$v.$invalid"
      first
    />
  </b-container>
</template>

<style lang="scss" scoped>
h2 {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
</style>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

import WizardPageTitle from './widgets/WizardPageTitle.vue';
import WizardPrevNext from './widgets/WizardPrevNext.vue';
import navigationMixin from './mixins/navigation';

export default {
  name: 'ProjectDetails',
  components: {
    WizardPageTitle,
    WizardPrevNext,
  },
  mixins: [validationMixin, navigationMixin],
  data() {
    return {
      name: this.$store.state.recipe.name,
      description: this.$store.state.recipe.description,
      platform: this.$store.state.recipe.platform,
    };
  },
  validations: {
    name: {
      required,
    },
  },
  computed: {
    platformChoices() {
      return [
        { value: 'django', text: 'Django (Python)' },
        { value: 'express', text: 'Express (NodeJS)' },
      ];
    },
  },
  watch: {
    '$v.$invalid': function watchError() {
      if (this.$v.$invalid) {
        this.$store.commit('setError', true);
      } else {
        this.$store.commit('clearError');
      }
    },
  },
  methods: {
    // returns proper VueBoostrap state value based on presence/absence of error
    errState(validation) {
      return validation.$error ? false : null;
    },
    commit() {
      if (this.$v.$invalid) return false;

      const { name, description, platform } = this;
      this.$store.commit('updateRecipe', { name, description, platform });
      return true;
    },
  },
};
</script>
